import type { TurnstileInstance } from '@marsidev/react-turnstile';
import { Turnstile } from '@marsidev/react-turnstile';
import { useRef } from 'react';

import { CAPTCHA_PROVIDER } from '@shared/components/captcha/constants';
import { getTurnstileSitekey, googleCaptchaSitekeyV3 } from '@shared/configs/configs/config';

import useCaptchaProvider from '../useCaptchaProvider';

const useInvisibleCaptcha = () => {
  const turnstileRef = useRef<TurnstileInstance>(null);
  const { captchaProvider } = useCaptchaProvider();

  const getToken = async (): Promise<string | undefined> => {
    if (captchaProvider === CAPTCHA_PROVIDER.turnstile) {
      turnstileRef.current?.execute?.();
      return turnstileRef.current?.getResponsePromise();
    }

    return new Promise((resolve, reject) => {
      window.grecaptcha.ready(() => {
        window.grecaptcha.execute(googleCaptchaSitekeyV3(), { action: 'submit' }).then(resolve).catch(reject);
      });
    });
  };

  const turnstileWidget = captchaProvider === CAPTCHA_PROVIDER.turnstile && (
    <Turnstile
      options={{
        execution: 'execute',
        size: 'invisible',
      }}
      ref={turnstileRef}
      siteKey={getTurnstileSitekey()}
    />
  );

  return { getToken, turnstileWidget, captchaProvider };
};
export default useInvisibleCaptcha;
